import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { useLocation } from 'react-router-dom';

import {
  markPwaInstalled,
  markVoiceSetupDone,
  shouldShowVoiceSetupOnInstall,
} from '../../ai/supportChatVoiceAssistant';
import VoiceAssistantSetupPanel from './VoiceAssistantSetupPanel';

type VoiceAssistantInstallModalProps = {
  isSignedIn: boolean;
};

/** One-time Siri / Google Assistant setup when SOC is installed to home screen. */
const VoiceAssistantInstallModal: React.FC<VoiceAssistantInstallModalProps> = ({ isSignedIn }) => {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onInstalled = () => markPwaInstalled();
    window.addEventListener('appinstalled', onInstalled);
    return () => window.removeEventListener('appinstalled', onInstalled);
  }, []);

  useEffect(() => {
    if (!isSignedIn || location.pathname !== '/home') return;
    if (!shouldShowVoiceSetupOnInstall()) return;
    setOpen(true);
  }, [isSignedIn, location.pathname]);

  const finish = () => {
    markVoiceSetupDone();
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      title="Voice booking setup"
      footer={null}
      onCancel={finish}
      destroyOnClose
      centered
      width={480}
    >
      <VoiceAssistantSetupPanel onComplete={finish} />
    </Modal>
  );
};

export default VoiceAssistantInstallModal;
